import { create } from 'zustand';
import { PageOwnerIdentity } from '../dto/EntityRepository';


interface PageOwnerIdentityAction {
  pageOwner: PageOwnerIdentity | null;
  setPageOwner: (aui: string, handle: string) => void;
  clearPageOwner: () => void;
};

export const usePageOwnerIdentityStore = create<PageOwnerIdentityAction>((set) => ({
  pageOwner: null,
  setPageOwner: (aui, handle) =>
    set((s) => {
      // 이미 세팅되어 있으면 리턴
      if (s.pageOwner?.aui === aui && s.pageOwner?.handle === handle) return s;
      return { pageOwner: { aui, handle } };
    }),
  clearPageOwner: () => set(() => ({ pageOwner: null })),
}));